<template>
  <div class="card bg-light p-3 pb-0" style="box-shadow: none">
    <div class="row" :style="{ opacity: readonly ? 0.3 : 1 }">
      <div class="col-12">
        <label :for="id_input" class="form-label-group-label shorter">{{
          label
        }}</label>
      </div>
      <div class="col-12 col-md-8 pr-md-1">
        <span
          :class="[
            'bmd-form-group mb-2 d-block form-label-group',
            required ? 'required' : '',
          ]"
        >
          <vue-tags-input
            :readonly="readonly"
            :id="id_input"
            type="text"
            style="width: 100%"
            class=""
            v-model="code"
            :placeholder="label"
            :tags="value_"
            :autocomplete-items="autocompleteitems"
            @tags-changed="update"
            :addOnBlur="true"
            :addOnPaste="false"
            :addOnlyFromAutocomplete="false"
          ></vue-tags-input>
          <!---->
        </span>
      </div>
      <div class="col-12 col-md-4 pl-md-1">
        <button
          id="select-by-params-btn"
          :disabled="readonly"
          style="height: 35px"
          class="btn btn-outline-secondary btn-sm w-100"
          type="button"
          @click.prevent.stop="initSelecting"
          v-if="!is_selecting"
        >
          {{ $t("message.select") }}
          <!--<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation" class="vs__open-indicator"><path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"></path></svg>-->
        </button>
        <button
          class="btn btn-outline-secondary btn-sm w-100"
          type="button"
          @click.prevent.stop="initSelecting"
          v-if="is_selecting"
        >
          {{ $t("message.deselect") }}
          <!--<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation" class="vs__open-indicator" style="transform: rotate(180deg)"><path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"></path></svg>-->
        </button>
      </div>
    </div>
    <div class="form-group" v-if="is_selecting">
      <span
        :class="[
          'bmd-form-group mb-2 d-block form-label-group',
          select_1_focused ? 'focused' : '',
        ]"
      >
        <v-select
          :id="id_select_1"
          :options="select_1_values"
          label="display_text"
          :class="[
            'form-control',
            typeof select_1_selected !== 'undefined' &&
            select_1_selected.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          v-model="select_1_selected"
          :placeholder="label2"
          @focus="select_1_focused = true"
          @blur="select_1_focused = false"
          @search="loadSelect1"
        ></v-select>
        <label :for="id_select_1" class="form-label-group-label shorter">{{
          label2
        }}</label>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 d-block form-label-group',
          select_2_focused ? 'focused' : '',
        ]"
        v-if="select_1_selected.value !== ''"
      >
        <v-select
          :id="id_select_2"
          :options="select_2_values"
          label="display_text"
          :class="[
            'form-control',
            typeof select_2_selected !== 'undefined' &&
            select_2_selected.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          v-model="select_2_selected"
          :placeholder="label3"
          @focus="select_2_focused = true"
          @blur="select_2_focused = false"
          @search="loadSelect2"
        ></v-select>
        <label :for="id_select_2" class="form-label-group-label shorter">{{
          label3
        }}</label>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 d-block form-label-group',
          select_3_focused ? 'focused' : '',
        ]"
        v-if="select_2_selected.value !== ''"
      >
        <v-select
          :id="id_select_3"
          :options="select_3_values"
          label="display_text"
          :class="[
            'form-control',
            typeof select_3_selected !== 'undefined' &&
            select_3_selected.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          v-model="select_3_selected"
          :placeholder="label4"
          @focus="select_3_focused = true"
          @blur="select_3_focused = false"
          @search="loadSelect3"
        ></v-select>
        <label :for="id_select_3" class="form-label-group-label shorter">{{
          label4
        }}</label>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 d-block form-label-group',
          select_4_focused ? 'focused' : '',
        ]"
        v-if="select_3_selected.value !== ''"
      >
        <v-select
          :id="id_select_4"
          :options="select_4_values"
          label="display_text"
          :class="[
            'form-control',
            typeof select_4_selected !== 'undefined' &&
            select_4_selected.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          v-model="select_4_selected"
          :placeholder="label5"
          @focus="select_4_focused = true"
          @blur="select_4_focused = false"
          @search="loadSelect4"
        ></v-select>
        <label :for="id_select_4" class="form-label-group-label shorter">{{
          label5
        }}</label>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 d-block form-label-group',
          select_5_focused ? 'focused' : '',
        ]"
        v-if="select_4_selected.value !== ''"
      >
        <v-select
          :id="id_select_5"
          :options="select_5_values"
          label="display_text"
          :class="[
            'form-control',
            typeof select_5_selected !== 'undefined' &&
            select_5_selected.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          v-model="select_5_selected"
          :placeholder="label6"
          @focus="select_5_focused = true"
          @blur="select_5_focused = false"
          @search="loadSelect5"
        ></v-select>
        <label :for="id_select_5" class="form-label-group-label shorter">{{
          label6
        }}</label>
      </span>
    </div>
  </div>
</template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "claster-selector",
  components: {
    VueTagsInput,
  },
  props: {
    label: String,
    label2: String,
    label3: String,
    label4: String,
    label5: String,
    label6: String,
    type: String,
    required: Boolean,
    value: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      code: "",
      autocompleteitems: [],
      is_selecting: false,
      select_1_focused: false,
      select_2_focused: false,
      select_3_focused: false,
      select_4_focused: false,
      select_5_focused: false,
      select_1_values: [],
      select_2_values: [],
      select_3_values: [],
      select_4_values: [],
      select_5_values: [],
      select_1_selected: { value: "" },
      select_2_selected: { value: "" },
      select_3_selected: { value: "" },
      select_4_selected: { value: "" },
      select_5_selected: { value: "" },
      value_: [],
      is_loaded: false,
    };
  },
  mounted() {
    this.loadSelect1("");
    if (this.value !== "") {
      if (
        !this.is_loaded &&
        typeof this.value !== "undefined" &&
        this.value != ""
      ) {
        axios
          .get(
            window.base +
              "/classification?type=" +
              this.type +
              "&level=names&query=" +
              this.value +
              "&qty=10" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            this.is_loaded = true;
            this.value_ = _.map(response.data, (i) => {
              i.text = i.display_text;
              return i;
            });
          });
      }
    }
  },
  methods: {
    loadSelect1(q) {
      let query = q.toLowerCase();
      let qty = 1000;
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level=1&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.select_1_values = [];
          response.data.forEach((item) => {
            this.select_1_values.push(item);
          });
        });
    },
    loadSelect2(q) {
      let query = q.toLowerCase();
      let qty = 1000;
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level_1=" +
            this.select_1_selected.value +
            "&level=2&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.select_2_values = [];
          response.data.forEach((item) => {
            this.select_2_values.push(item);
          });
        });
    },
    loadSelect3(q) {
      let query = q.toLowerCase();
      let qty = 1000;
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level_1=" +
            this.select_1_selected.value +
            "&level_2=" +
            this.select_2_selected.value +
            "&level=3&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.select_3_values = [];
          response.data.forEach((item) => {
            this.select_3_values.push(item);
          });
        });
    },
    loadSelect4(q) {
      let query = q.toLowerCase();
      let qty = 1000;
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level_1=" +
            this.select_1_selected.value +
            "&level_2=" +
            this.select_2_selected.value +
            "&level_3=" +
            this.select_3_selected.value +
            "&level=4&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.select_4_values = [];
          response.data.forEach((item) => {
            this.select_4_values.push(item);
          });
        });
    },
    loadSelect5(q) {
      let query = q.toLowerCase();
      let qty = 1000;
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level_1=" +
            this.select_1_selected.value +
            "&level_2=" +
            this.select_2_selected.value +
            "&level_3=" +
            this.select_3_selected.value +
            "&level_4=" +
            this.select_4_selected.value +
            "&level=5&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.select_5_values = [];
          response.data.forEach((item) => {
            item.display_text = item.display_text;
            this.select_5_values.push(item);
          });
        });
    },
    loadInfoByCode() {
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level=last&query=" +
            this.value_ +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.select_5_selected = response.data;
        });
    },
    initSelecting() {
      this.is_selecting = !this.is_selecting;
    },
    search_items() {
      if (this.code.length < 2) return;
      axios
        .get(
          window.base +
            "/classification?type=" +
            this.type +
            "&level=search&query=" +
            this.code +
            "&qty=1000" +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.autocompleteitems = _.map(response.data, (item) => {
            item.text = item.display_text;
            return item;
          });
        });
    },
    update(c) {
      this.value_ = c;
      // this.value_.push({text: c[0].text, value: c[0].value})
    },
  },
  computed: {
    id_input() {
      return "claster-selector-input-" + this._uid;
    },
    id_select_1() {
      return "claster-selector-select-1-" + this._uid;
    },
    id_select_2() {
      return "claster-selector-select-2-" + this._uid;
    },
    id_select_3() {
      return "claster-selector-select-3-" + this._uid;
    },
    id_select_4() {
      return "claster-selector-select-4-" + this._uid;
    },
    id_select_5() {
      return "claster-selector-select-5-" + this._uid;
    },
  },
  watch: {
    select_1_selected() {
      this.loadSelect2("");
    },
    select_2_selected() {
      this.loadSelect3("");
    },
    select_3_selected() {
      this.loadSelect4("");
    },
    select_4_selected() {
      this.loadSelect5("");
    },
    select_5_selected: {
      deep: true,
      handler() {
        if (
          this.value_.findIndex((i) => {
            i.value == this.select_5_selected.value_;
          }) == -1 &&
          this.select_5_selected.value !== ""
        ) {
          this.value_.push({
            text: this.select_5_selected.display_text,
            value: this.select_5_selected.value,
          });
          this.select_5_selected = { value: "" };
          this.select_4_selected = { value: "" };
          this.select_3_selected = { value: "" };
          this.select_2_selected = { value: "" };
          this.select_1_selected = { value: "" };
        }
      },
    },
    value_() {
      // if(!this.is_selecting)
      // this.loadInfoByCode()
      this.$emit(
        "input",
        _.join(
          _.map(this.value_, (i) => {
            if (typeof i.value !== "undefined") return i.value;
            return i.text;
          }),
        ),
      );
    },
    code() {
      this.search_items();
    },
    value() {
      if (
        !this.is_loaded &&
        typeof this.value !== "undefined" &&
        this.value != ""
      ) {
        axios
          .get(
            window.base +
              "/classification?type=" +
              this.type +
              "&level=names&query=" +
              this.value +
              "&qty=10" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            this.is_loaded = true;
            this.value_ = _.map(response.data, (i) => {
              i.text = i.display_text;
              return i;
            });
          });
      }
    },
  },
};
</script>
<style scoped="">
.vue-tags-input {
  width: 100% !important;
  max-width: 100% !important;
}
</style>
